import { ProductImageTag } from '../productdetail/types';
import { ProductInterface } from './types';

const generateProductPlaceHolders = (count: number): ProductInterface[] => {
    const productPlaceHolders: ProductInterface[] = [];
    for (let i = 0; i < count; i++) {
        productPlaceHolders.push({
            sku: '',
            simpleSku: '',
            baseImage: 'placeholder_image_url',
            name: '',
            altTag: '',
            brand: '',
            blackFriday: false,
            cyberMonday: false,
            price: '',
            originalPrice: '',
            link: '',
            simplesCount: 0,
            position: i,
            quantityBadge: 0,
            soldOut: false,
            productImage: {
                path: '',
                seoUrl: '',
                tag: ProductImageTag.REGULAR,
            },
        });
    }

    return productPlaceHolders;
};

export default generateProductPlaceHolders;
